import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './helpers/useAuth';

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import CreateStudentFee from './pages/CreateStudentFee';
import StudentReport from './pages/StudentReport';
import ProtectedRoute from './helpers/ProtectedRoutes';
import StudentRegistration from './pages/StudentRegistration';
import UnpaidStudents from './pages/UnpaidStudentsReport';
import ScrollToTop from './components/ScrollToTop';
import { useState } from 'react';
import DocumentsChecklist from "../src/pages/Checklist";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <AuthProvider>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          },
        }}
      />

      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Documents Checklist - Outside ProtectedRoute, No Sidebar/Header */}
        <Route path="/documents-checklist" element={<DocumentsChecklist />} />

        {/* Protected Routes with Sidebar and Header */}
        <Route element={<ProtectedRoute />}>
          <Route
            element={
              <div className="flex h-screen bg-gray-100">
                <Sidebar sidebarOpen={sidebarOpen} />
                <div className="flex-1 flex flex-col overflow-hidden">
                  <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                  <main className="flex-1 p-6 overflow-auto">
                    <ScrollToTop />
                    <Outlet />
                  </main>
                </div>
              </div>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="student-registration" element={<StudentRegistration />} />
            <Route path="unpaid-studentfee" element={<UnpaidStudents />} />
            <Route path="create-studentfee" element={<CreateStudentFee />} />
            <Route path="student-report" element={<StudentReport />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;